
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../data/client/api-endpoints';
import { getIndicesDetails } from './client/indices-details';
import { mapPaginatorData } from '../utils/data-mappers';


export const useIndicesCompaniesQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.INDICES + '/'+params.id, params],
    queryFn: () => getIndicesDetails.get( { id:params.id, ...params } ),
    keepPreviousData: true,
  });
  //console.log("Screen details data:", params, data);
  return {
    product: data?.data,
    indicesDetails: data ? data.indices : undefined,
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useIndicesQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.INDICES, params],
    queryFn: () => getIndicesDetails.all( params ),
    keepPreviousData: true,
  });
  console.log("Indices list data:", params, data);
  return {
    sectors: data?.data,    
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};
